/**
 * Ruby-gradient initials avatars for a role's members — mockup's avatar
 * stack, max 3 shown + "+N" overflow, each with a name+email tooltip.
 */
import type { StaffMember } from '../../../services/staffApi';

/** First-letter-of-each-word initials, max 2 chars — "Bob Jones" -> "BJ", "cher" -> "C". */
export function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function MemberAvatars({ members }: { members: StaffMember[] }) {
  if (members.length === 0) return null;
  const shown = members.slice(0, 3);
  const overflow = members.length - shown.length;
  return (
    <div className="flex items-center" role="group" aria-label={`Members: ${members.map((m) => m.name).join(', ')}`}>
      {shown.map((m, i) => (
        <span
          key={m.id}
          title={`${m.name} (${m.email})`}
          className={`w-7 h-7 rounded-full bg-gradient-to-br from-[#DC143C] to-[#9F1239] text-white text-xs flex items-center justify-center ring-2 ring-white ${i > 0 ? '-ml-2' : ''}`}
        >
          {initialsOf(m.name)}
        </span>
      ))}
      {overflow > 0 && (
        <span
          title={members.slice(3).map((m) => m.name).join(', ')}
          className="w-7 h-7 rounded-full bg-stone-200 text-stone-700 text-xs flex items-center justify-center -ml-2 ring-2 ring-white"
        >
          +{overflow}
        </span>
      )}
    </div>
  );
}

export default MemberAvatars;
